import OncePerIterationRemark from './OncePerIterationRemark';

class OncePerNrCalendarYearsGroupRemark extends OncePerIterationRemark {
    OtherNomenclatureNumber: string;
    OtherProcedureCode: string;

    info(t: Function): React.ReactElement {
        return (
            <p>
                {t('Nomenclature')}
                {' '}
                {this.NomenclatureNumber}
                {' '}
                {t('From')}
                {' '}
                {t('Procedure')}
                {' '}
                {this.ProcedureCode}
                {' '}
                {t('CanNotBeAdded')}
                {t('HadGroupNomenclature')}
                {' '}
                {t('NomenclatureGroupRestrictionsYear')}
                {' '}
                {this.PerIteration}
                {' '}
                {t('Yearss')}
                .
                {this.OtherNomenclatureNumber}
                {' '}
                {t('From')}
                {' '}
                {this.OtherProcedureCode}
                {' '}
                {t('on')}
                {' '}
                {this.Date?.toDateString()}
                {' '}
                {t('In')}
                {' '}
                <a href={`~/Orders/Detail/${this.OrderID}`} className="ajaxLinkNav">{t('Order')} #{this.OrderID}</a>
                {' '}
                <span>(</span>
                <a href={`~/Invoices/DetailConfirmed/${this.InvoiceID}`} className="ajaxLinkNav">{t('Invoice')} #{this.InvoiceID}</a>
                <span>).</span>
            </p>
        );
    }

    constructor(nomenclatureNumber: string, procedureCode: string, date: Date, perIteration: number, orderID: number, invoiceID: number, otherNomenclatureNumber: string, otherProcedureCode: string) {
        super(nomenclatureNumber, procedureCode, date, perIteration, orderID, invoiceID);
        this.OtherNomenclatureNumber = otherNomenclatureNumber;
        this.OtherProcedureCode = otherProcedureCode;
    }
}

export default OncePerNrCalendarYearsGroupRemark;
